import { reservationTableDisplayName } from 'webReservations/utils/reservationTableDisplayName';
import { useDocumentTitle } from '@shared/hooks/setDocumentTitle';
import { reportAppError } from '@shared/reportAppError';
import { useEffect, useState } from 'react';
import { useGuestLandingPaths } from 'webReservations/hooks/useGuestLandingPaths';
import { EmptyState } from '../components/EmptyState';
import type { Reservation } from './apiHelpers';
import { getInactiveReservations } from './apiHelpers';
import { ReservationCard } from './ReservationCard';
import styles from './ReservationTabs.scss';
import { getReservationStatusLabel } from './statusHelpers';

const NO_RESERVATIONS = 0;

export const InactivePage = () => {
  const { reservationDetailsPath } = useGuestLandingPaths();
  const [inactiveReservations, setInactiveReservations] = useState<
    Reservation[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);
  useDocumentTitle('My Inactive Reservations | Peak Reservations');

  useEffect(() => {
    const fetchInactiveReservations = async () => {
      try {
        const response = await getInactiveReservations();
        setInactiveReservations(response);
      } catch (error) {
        reportAppError(error);
      }
      setIsLoading(false);
    };
    fetchInactiveReservations();
  }, []);

  if (inactiveReservations.length === NO_RESERVATIONS && !isLoading) {
    return (
      <EmptyState
        title="No Reservations"
        subtitle="World-class experiences await. Book your next reservation today."
      />
    );
  }

  return (
    <ul className={styles.container}>
      {inactiveReservations.map((reservation) => (
        <ReservationCard
          date={reservation.date}
          eventName={reservation.restaurantEvent?.name}
          guestCount={reservation.guestCount}
          restaurant={reservation.restaurant}
          listingPublicName={reservationTableDisplayName(reservation)}
          time={reservation.time}
          key={JSON.stringify(reservation)}
          linkTo={reservationDetailsPath(
            reservation.id,
            reservation.restaurant,
          )}
          status={getReservationStatusLabel(
            reservation,
            reservation.restaurant.timezone,
          )}
        />
      ))}
    </ul>
  );
};
